import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
} from "@angular/core";

@Component({
  selector: "live-indicator",
  templateUrl: "./liveIndicator.component.html",
  styleUrls: ["./liveIndicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveIndicatorComponent {
  @Input()
  @HostBinding("class.live")
  isLive: boolean = false;
}
